import { TablesInsert } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useCreateProject() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationKey: ["solvers"],
        mutationFn: async (data: TablesInsert<'project'>) => {
            const res = await supabase.from('project').insert(data).throwOnError().select().maybeSingle().then(res=>res.data);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['project'],exact: false});
            queryClient.invalidateQueries({queryKey: ['projects_list_empty_crm']})
        }
    });
}
